import React from "react";
import { AppShell } from "@astryxdesign/core";

export interface AppLayoutProps {
  /** The app's side navigation — typically a `GlobalNavRail`. */
  sideNav: React.ReactNode;
  /** Main content area. */
  children: React.ReactNode;
}

/**
 * Application-level layout shell. Thin wrapper around Astryx's `AppShell`
 * (side nav + main content, with an auto-generated mobile drawer below the
 * breakpoint). `contentPadding` is `0` because every page already manages
 * its own spacing via `PageContainer`/`ContentContainer`.
 */
const AppLayout = ({ sideNav, children }: AppLayoutProps): React.ReactElement => {
  return (
    <AppShell sideNav={sideNav} contentPadding={0}>
      {children}
    </AppShell>
  );
};

export default AppLayout;
